import { render, staticRenderFns } from "./MantenedorGridVerDetalle.vue?vue&type=template&id=73dc0eb8&"
import script from "./MantenedorGridVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./MantenedorGridVerDetalle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports